import VueJwtDecode from 'vue-jwt-decode'

const state = {
    user: {},
    authenticated: false,
    database : 0,
    token: '',
    userid: 0,
    nbf : '',
    exp : '',
    langue: [
        {
        id: 1,
        langue: 'Français / French'
        },
        {
        id: 2,
        langue: 'English / Anglais'
        }
    ]
}
const getters = {
    getUser             :(state) => state.user,
    getLangue           :(state) => state.langue,
    isAuthenticated     :(state, getters, rootState) => {
        return typeof state.token === 'string' 
        && state.token !== "" 
        && state.authenticated 
        && state.userid > 0 
        && JSON.stringify(rootState.user.user) === JSON.stringify(state.user)
    }, 
    getUserName         :(state) => state.user ? state.user.nom : "",
    getToken            :(state) => state.token,
    getAccessToken      :(state) => state.token,
    getUserId           :(state) => state.userid,
    getNotBeforeDat     :(state) => state.nbf,
    getExpirationDate   :(state) => state.exp,
    getDatabase         :(state) => state.database,
    getLicences         :(state,getters, rootState) => {
        let list = rootState.user.user.licenceList
        let licences = []
        if(list!='')  licences = list.split(";")
        return licences
    }

}
const mutations = {
    changeLogin: (state, payload) => {
        state.login = payload
    },
    SET_USER: (state, payload) => {
        state.user = payload
    },
    SET_DATABASE: (state, payload) => {
        state.database = payload
    },
    SET_SESSION(state, payload) {
        const accessToken = payload.token;
        const user = payload.user;
        const loggedIn = typeof accessToken === 'string' && accessToken !== "" && user.id > 0;

        let decoded = VueJwtDecode.decode(accessToken)
        const nbf=new Date(decoded.nbf * 1000).toLocaleString()
        const exp=new Date(decoded.exp * 1000).toLocaleString()

        state.user = user
        state.authenticated = loggedIn
        state.token = accessToken
        state.userid = user.id
        state.nbf = nbf
        state.exp = exp,
        state.database = payload.licence
    },
    DELETE_SESSION(state) {
        sessionStorage.clear()
        state.token = ''
        state.userid = 0
        state.nbf = ''
        state.exp = ''
        state.authenticated = false
        state.database = '0',
        state.user = {}
    }
}
const actions = {
    setSession : (context, payload) => {
        const sessionData = payload
        context.commit('SET_SESSION',sessionData)
    },
    deleteSession : (context) => {
        console.log('deleteSession')
        context.commit('DELETE_SESSION')
    },
    setUser : (context, payload) => {
        console.log('setUser')
        context.commit('SET_USER',payload)
    },
    setDatabase : (context, payload) => {
        console.log('setDatabase')
        context.commit('SET_DATABASE',payload)
    },
    
}

export default{
    state,
    mutations,
    getters,
    actions
}